__webpack_require__.p = "/duretechnologies/";